import { apiGet, apiPost } from '../Utils/apiFetch';
import apiPath from '../Utils/apiPath';

export function mediaUrl(path) {
  if (!path) return '';
  try {
    const url = new URL(path, process.env.REACT_APP_API_BASE_URL || 'https://vrnlapi365.com:5038/');
    return ['http:', 'https:'].includes(url.protocol) ? url.href : '';
  } catch { return ''; }
}
export function eligibleOffers(offers, depositCount = 0, now = Date.now()) {
  const consumed = ['OnFirstDeposit','OnSecondDeposit','OnThirdDeposit','OneFourthDeposit'].slice(0, Math.max(0, depositCount));
  return offers.filter(o => o.isActive !== false && !o.isDelete && !consumed.includes(o.offerOn)
    && (!o.offerStartDateTime || Date.parse(o.offerStartDateTime) <= now)
    && (!o.offerEndDateTime || Date.parse(o.offerEndDateTime) >= now))
    .sort((a,b) => (a.displayOrder || 0) - (b.displayOrder || 0));
}
function result(response) {
  if (!response.data?.success) throw new Error(response.data?.message || 'Unable to load data');
  return response.data.results;
}
export async function fetchOffers() { return result(await apiGet(apiPath.getPromotional)).offerList || []; }
export async function fetchBanners() { return result(await apiPost(apiPath.getBanner, {type:'home_top'})).banners || []; }
export async function fetchProfile() { return result(await apiGet(apiPath.userProfile)); }
export async function refreshBalance() { return result(await apiGet(apiPath.refreshAmount)); }

export async function loginUser(username, password) {
  const response = await apiPost(apiPath.loginUser, {
    username,
    password,
    uniqueId: Math.random() * 10000,
    website: "ck75.live",
  });
  if (response.status === 200 && response.data?.success) {
    const results = response.data.results || {};
    localStorage.setItem("token", results.token || "");
    localStorage.setItem("refresh_token", results.refresh_token || "");
    localStorage.setItem("userId", results._id || "");
    if (results.visiterChatId) localStorage.setItem("visiterChatId", results.visiterChatId);
    if (results.platformType) localStorage.setItem("chatId", results.platformType);
    return results;
  }
  throw new Error(response.data?.message || "Login failed");
}
